import React, { FunctionComponent } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { LoginCallback } from '@okta/okta-react'
import { EnvironmentProvider } from 'view/shared/environment'
import { AuthProvider } from './login/AuthProvider'
import { OktaLoginFormLazy } from './login/OktaLoginFormLazy'
import { Logout } from './login/Logout'
import { LoginIdpDiscovery } from './login/LoginIdpDiscovery'
import { RequiredAuth } from './login/RequireAuth'
import { AuthContent } from './login/AuthContent'
import { GlobalNavigation } from './header/GlobalNavigation'
import { GrowlList } from './growl/GrowlList'
import { MainContent } from './MainContent'
import { LoginBackground } from './login/LoginBackground'
import { useDispatch } from 'react-redux'
import { ConnectionActions } from 'store/connection'
import { useOnMount } from 'view/hooks'

const ErrorComponent = ({ error }: { error: Error }) => {
  const dispatch = useDispatch()

  useOnMount(() => {
    dispatch(ConnectionActions.signOut(`${error.name}: ${error.message}`))
  })

  return null
}

export const Main: FunctionComponent = () => {
  const navigate = useNavigate()

  const onAuthResume = async () => {
    navigate('/login')
  }

  return (
    <EnvironmentProvider isTearout={false}>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<OktaLoginFormLazy />} />
          <Route path="/logout" element={<Logout />} />
          {/* TODO: Potentially merge /implicit/callback with /idpDiscovery */}
          <Route
            path="/implicit/callback"
            element={
              <LoginCallback
                onAuthResume={onAuthResume}
                loadingElement={<LoginBackground showSpinner={true} />}
                errorComponent={ErrorComponent}
              />
            }
          />
          <Route path="/idpDiscovery" element={<LoginIdpDiscovery />} />
          <Route path="/*" element={<RequiredAuth />}>
            <Route
              path="*"
              element={
                <AuthContent isMainWindow={true}>
                  <GlobalNavigation>
                    <MainContent />
                  </GlobalNavigation>
                  <GrowlList />
                </AuthContent>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </EnvironmentProvider>
  )
}
